import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'
import {doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_TASK_SET_ADD_ITEM = 'REQUEST_TASK_SET_ADD_ITEM'
export const doREQUEST_TASK_SET_ADD_ITEM = createDoRequestAction(REQUEST_TASK_SET_ADD_ITEM)

export const requestTaskSetAddItemActionCreators = {
  doREQUEST_TASK_SET_ADD_ITEM,
}

export function* requestTaskSetAddItem({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestTaskSetAddItem')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        taskSetId: v.string().uuid().exist(),
        taskSetItemId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_SET_ADD_ITEM,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {taskSetId, taskSetItemId} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/task-set-add-item`,
    accessToken,
    data: {
      taskSetId,
      taskSetItemId,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_SET_ADD_ITEM,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/task-set-add-item',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_SET_ADD_ITEM,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* taskSetAddItemSaga() {
  yield takeEvery(REQUEST_TASK_SET_ADD_ITEM, requestTaskSetAddItem)
}
